import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TextInput } from '@components';
import { TransitDuplicateRow } from '../../../TransitDuplicateRow';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseTransportProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  disabled: boolean;
  editDisabledConditionalForArrival: boolean;
}

export const HouseTransport: React.FC<HouseTransportProps> = (props) => {
  const { form, houseForm, editDisabledConditionalForArrival } = props;

  return (
    <Stack mt="md">
      <Title order={5} fw={600}>
        Departure transport means
      </Title>

      {(form?.values?.Consignment?.DepartureTransportMeans || []).map((means, meansIdx) => (
        <Grid key={meansIdx}>
          <Grid.Col span={4}>
            <TextInput label="Type of identification" value={means.typeOfIdentification} disabled />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput label="Identification number" value={means.identificationNumber} disabled />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput label="Nationality" value={means.nationality} disabled />
          </Grid.Col>
        </Grid>
      ))}

      <TransitDuplicateRow
        form={houseForm}
        addButtonLabel="Add"
        addButtonDataPW="add-departure-transport-means-btn"
        inputs={[
          {
            type: 'MultiLang',
            name: 'typeOfIdentification',
            label: 'Type of identification',
            code: 'CL750',
            width: 32,
          },
          {
            type: 'Input',
            name: 'identificationNumber',
            label: 'Identification number',
            width: 32,
          },
          {
            type: 'MultiLang',
            name: 'nationality',
            label: 'Nationality',
            code: 'CL165',
            width: 20,
          },
        ]}
        arrayPath="DepartureTransportMeans"
        disabled={editDisabledConditionalForArrival}
      />
    </Stack>
  );
};
